import clsx from "clsx";
import { useAtom } from "jotai";
import { useCallback } from "react";

import { SNHU_EXTRA_ENTRIES } from "../../constants/snhu.constants";
import { pagesAtom } from "../../snhu.state";
import { Pages } from "../../snhu.types";

interface OptInPageProps {
  skipSnhu: VoidFunction;
}

export function OptInPage({ skipSnhu }: OptInPageProps): JSX.Element {
  const [, setPage] = useAtom(pagesAtom);

  const goToSurvey = useCallback(() => {
    setPage(Pages.SURVEY);
  }, [setPage]);

  return (
    <div className="snhu__children__container">
      <div className="snhu__children">
        <div className="snhu__children--entries-box">
          +{SNHU_EXTRA_ENTRIES} Entries
        </div>
        <p className="snhu__children--title">
          Are you considering continuing your education with an online degree in the next 6 months?
        </p>
      </div>

      <div className={clsx("lander__cpl__quiz__body", "snhu__content--buttons-body")}>
        <div className="lander__cpl__quiz__body--question-container">
          <div className="lander__cpl__quiz__body--question-actions">
            <div className="lander__cpl__quiz__body--button-container">
              <button className="lander-quiz--button" onClick={goToSurvey}>
                Yes
              </button>
            </div>
            <div className="lander__cpl__quiz__body--button-container">
              <button className="lander-quiz--button" onClick={skipSnhu}>
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
